import React from 'react'
import { TextField } from 'mui-rff'
import { Typography, Button, Box } from '@mui/material'
import { Form } from 'react-final-form'
import { Link, useNavigate } from 'react-router-dom'
import { useForgotPassword } from '../../api/user'
import { useSnackbar } from 'notistack'

const ForgotPasswordForm = () => {
  const { mutateAsync } = useForgotPassword()
  const { enqueueSnackbar } = useSnackbar()

  const navigate = useNavigate()

  const onSubmit = async (values) => {
    const res = await mutateAsync(values).catch((err) => {
      enqueueSnackbar(err?.response?.data?.message ?? 'The email is invalid.', {
        variant: 'error',
      })
    })
    if (res?.status === 200) {
      enqueueSnackbar('Requested to retrieve password.', {
        variant: 'success',
      })
      navigate('/login')
    }
    return res
  }

  const formFields = [
    {
      size: 12,
      field: <TextField type='email' label='Email' name='email' margin='none' required={true} />,
    },
  ]
  return (
    <Box boxSizing='border-box' m='auto' width='100%' maxWidth={500} mt={3} mb={10} p={5}>
      <Typography variant='h5'>Forgot your password?</Typography>
      <Form
        onSubmit={onSubmit}
        render={({ handleSubmit, submitting }) => (
          <form onSubmit={handleSubmit}>
            <Box
              display='flex'
              flexDirection='column'
              justifyContent='space-between'
              minHeight={120}
            >
              {formFields.map((item, idx) => (
                <Box xs={item.size} key={idx} display='flex' flexDirection='column'>
                  {item.field}
                </Box>
              ))}

              <Button
                variant='contained'
                type='submit'
                disabled={submitting}
                style={{ backgroundColor: 'black', color: 'white' }}
              >
                Send
              </Button>
            </Box>
          </form>
        )}
      />
      <Link to='/login' style={{ color: '#000' }}>
        <Button style={{ color: '#000' }}>Back to login</Button>
      </Link>
    </Box>
  )
}

export default ForgotPasswordForm
